import { ComponentPropsWithRef } from "react";
import * as styles from "./MediaBackground.css";
import clsx from "clsx";
import { Media, MediaProps } from "./Media";

export type MediaBackgroundProps = {
  hasPointerEvents?: boolean;
} & ComponentPropsWithRef<"div"> &
  MediaProps;

export const MediaBackground = ({
  media,
  children,
  hasPointerEvents = false,
  className,
  ...props
}: MediaBackgroundProps) => {
  return (
    <div
      className={clsx(
        className,
        styles.background({ hasPointerEvents: hasPointerEvents })
      )}
      id={`background-${props.id}`}
    >
      <Media media={media} className={styles.media} {...props}></Media>
    </div>
  );
};
